import { useMemo, useState } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { createTheme, ThemeProvider, useTheme, Box, Button, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import EditIcon from "@mui/icons-material/Edit"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import DeleteIcon from "@mui/icons-material/Delete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useNavigate } from "react-router-dom"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import AccionesPdf from "./AccionesPdf"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const CustomTable = () => {
  // para movernos a crear y editar
  const navigate = useNavigate()
  const columns = useMemo(
    () => [
      {
        accessorKey: "ciacodigo",
        header: "Código CIA",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "acccodigo",
        header: "Código",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "accion",
        header: "Acción",
        enableEditing: false,
        size: 80,
      },

      {
        accessorKey: "accusuisys",
        header: "Usuario Creacion",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "accfecisys",
        header: "Fecha de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "acchorisys",
        header: "Hora de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
      {
        accessorKey: "accusumsys",
        header: "Usuario MOdifica",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "accfecmsys",
        header: "Fecha Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "acchormsys",
        header: "Hora Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
    ],
    [],
  )

  const { mutateAsync: createAcciones, isPending: isCreatingAcciones } = useCreateAcciones()

  const {
    data: fetchedAcciones = [],
    isError: isLoadingAccionesError,
    isFetching: isFetchingAcciones,
    isLoading: isLoadingAcciones,
  } = useGetAcciones()

  const { mutateAsync: updateAccion, isPending: isUpdatingAccion } = useUpdateAcciones()

  const { mutateAsync: deleteAccion, isPending: isDeletingAccion } = useDeleteAccion()

  const openDeleteConfirmModal = async (row) => {
    if (window.confirm("¿Está seguro que quiere eliminar esta accion?")) {
      await deleteAccion(row.original.acccodigo)
    }
  }
  const table = useMaterialReactTable({
    columns,
    data: fetchedAcciones,
    enableEditing: true,
    initialState: {
      showColumnFilters: true,
    },
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    getRowId: (row) => row.acccodigo,
    // si se cargar el error al importar los datos
    muiToolbarAlertBannerProps: isLoadingAccionesError
      ? {
          color: "error",
          children: "Error en cargar las acciones",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              navigate(`editar/${row?.original.acccodigo}`, {
                state: row?.original,
              })
            }}
          >
            <img src={DetalleIcon} alt="Editar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <img src={EliminarIcon} alt="Grabar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingAcciones,
      isSaving: isCreatingAcciones || isUpdatingAccion || isDeletingAccion,
      showAlertBanner: isLoadingAcciones,
      showProgressBars: isFetchingAcciones,
    },
  })
  return (
    <>
      <MaterialReactTable table={table} />
      <CustomBackdrop isLoading={table.getState().isSaving} />
    </>
  )
}
function useGetAcciones() {
  return useQuery({
    queryKey: ["Acciones"],
    queryFn: async () => {
      // send api request here
      let response = await fetchwrapper("/Acciones/getAcciones")
      response = await response.json()
      response = response?.data
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return response
    },
    refetchOnWindowFocus: false,
  })
}

// hooks a los que se les asigna una api y se encargan de actualizar el estado del componente
function useCreateAcciones() {
  // hook para crear la zona
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (accion) => {
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    onMutate: (newAccion) => {
      queryClient.setQueryData(["Acciones"], (prevAcciones) =>
        prevAcciones?.map((prevAcciones) =>
          prevAcciones.acccodigo === newAccion.acccodigo ? newAccion : prevAcciones,
        ),
      )
    },
  })
}
// HASTA AQUI
function useUpdateAcciones() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (nivel) => {
      // send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    // client side optimistic update
    onMutate: (newAccionInfo) => {
      queryClient.setQueryData(["Acciones"], (prevAcciones) =>
        prevAcciones?.map((prevAcciones) =>
          prevAcciones.acccodigo === newAccionInfo.acccodigo ? newAccionInfo : prevAcciones,
        ),
      )
    },
  })
}
function useDeleteAccion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (codigoAccion) => {
      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      const response = await fetchwrapper(`/Acciones/deleteAccion/${codigoAccion}`, options)
      return response
    },
    // actualizacion optimista
    onMutate: (codigoAccion) => {
      queryClient.setQueryData(["Acciones"], (prevAcciones) =>
        prevAcciones?.filter((accion) => accion.acccodigo !== codigoAccion),
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["Acciones"] })
    },
    onSuccess: () => {
      alert("Accion eliminada con exito")
    },
    onError: () => {
      alert("No se pudo eliminar la accion")
    },
  })
}

const DataGridAcciones = () => {
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const {
    data: fetchedAcciones = [],
    isError: isLoadingAccionesError,
    isFetching: isFetchingAcciones,
    isLoading: isLoadingAcciones,
  } = useGetAcciones()
  const handleOpenModal = () => {
    setInfoGenerada(fetchedAcciones) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  console.log("info pdf", fetchedAcciones)
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate("/home/dashboard/Acciones")
  }
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <div>
      <Tooltip title="Crear Accion">
        <Button color="primary" onClick={() => navigate("crear")} sx={{ marginBottom: "15px" }}>
          <img src={CrearIcon} alt="Crear" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <Tooltip title="Imprimir">
        <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
          <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <DetalleImpresion
        open={openModal}
        handleClose={handleCloseModal}
        infoGenerada={fetchedAcciones}
        nombrePdf={"Acciones"}
        PdfComponent={AccionesPdf}
      />
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable />
      </ThemeProvider>
    </div>
  )
}
export default DataGridAcciones
